import React from "react";
import { connect } from "react-redux";
import { Button, InputNumber } from "antd";

import { cross } from "@/util";
import UserSelect from "./UserSelect";
import AjaxAction from "../../actions/AjaxAction.js";

import "./index.scss";

let UserCache = {
  expires: Date.now(),
  data: null,
};

class UserCostSelect extends React.Component {
  state = {
    userList: null,
    infoList: [],
  };

  checkUserList() {
    if (!this.state.userList) {
      let { dispatch } = this.props;
      let { data, expires } = UserCache;
      let that = this;

      function doFetch() {
        UserCache.data = dispatch(
          AjaxAction.users({
            key: JSON.stringify({
              trash: 0,
            }),
            pagesize: 1000,
          })
        ).then((res) => {
          UserCache.data = res.data;
          UserCache.expires = Date.now() + 300000;

          that.setState({
            userList: res.data,
          });

          return res;
        });
      }

      if (data && data instanceof Promise) {
        data.then((res) => {
          this.setState({
            userList: res.data,
          });
        });
      } else {
        if (!data || (data && expires <= Date.now())) {
          doFetch();
        } else {
          this.setState({
            userList: data,
          });
        }
      }
    }
  }

  handleAddEmpty = () => {
    let value = this.props.value;

    if (value) {
      if (typeof value == "string") {
        value = JSON.parse(value);
      }
    } else {
      value = [];
    }

    value.push([]);
    this.props.onChange(value);
  };

  handleDelete(item, index) {
    let value = this.props.value;
    value.splice(index, 1);
    this.props.onChange(value);
  }

  setKeyValue(index, key, e) {
    let infoList = this.props.value;
    if(this.props.name ==='advisers' && key === 1) {
      infoList[index][key] = typeof e == "object" ? e.target.value * 100 + "" : e * 100 + "";
    } else {
      infoList[index][key] = typeof e == "object" ? e.target.value + "" : e + "";
    }
    this.props.onChange(infoList);
  }

  render() {
    let { filter, disabled, value: outerInfoList } = this.props;
    let { userList } = this.state;

    if (outerInfoList) {
      if (typeof outerInfoList == "string") {
        outerInfoList = JSON.parse(outerInfoList);
      }
    } else {
      outerInfoList = [];
    }

    if (userList && filter) {
      userList = [].concat(userList);

      Object.keys(filter).forEach((key) => {
        userList = userList.filter((item) => {
          if (key === "oper") {
            const arr1 = (item.oper || "").split(",");
            const arr2 = filter.oper;

            return cross(arr1, arr2);
          }
          return (filter[key] || "").indexOf(item[key]) > -1;
        });
      });
    }

    return (
      <div
        className="dp-f user-cost-select"
        style={{ flexDirection: "column" }}
      >
        {outerInfoList.map((item, index) => {
          if (!item) return null;
          return (
            <div key={index} className="dp-f" style={{ marginBottom: 10 }}>
              <div
                className="dp-f a-c j-c"
                style={{ width: 200, marginRight: 10 }}
              >
                <p style={{ width: 60, margin: 0 }}>姓名：</p>
                <UserSelect
                  onChange={this.setKeyValue.bind(this, index, 0)}
                  filter={this.props.filter}
                  single={true}
                  value={item[0]}
                  disabled={disabled}
                  style={{ width: 160 }}
                />
              </div>
              <div
                className="dp-f a-c j-c"
                style={{ width: 200, marginRight: 10 }}
              >
                <p style={{ width: 60, margin: 0 }}>费用：</p>
                <InputNumber
                  style={{ width: 200 }}
                  disabled={disabled}
                  value={
                    window.actionFor("order-info-cost", "boolean") &&
                    window.actionFor("order-person-cost", "boolean")
                      ? "--.--"
                      : (this.props.name ==='advisers' ? item[1] / 100 : item[1])
                  }
                  min={0}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  onChange={this.setKeyValue.bind(this, index, 1)}
                />
                <span className="pl-2">元</span>
              </div>
              {!disabled ? (
                <div className="dp-f a-c" style={{ width: 200 }}>
                  <a onClick={this.handleDelete.bind(this, item, index)}>
                    删除
                  </a>
                </div>
              ) : null}
            </div>
          );
        })}
        {!disabled ? (
          <Button
            style={{ width: 100 }}
            onClick={this.handleAddEmpty}
            icon="plus"
          >
            添加一行
          </Button>
        ) : null}
      </div>
    );
  }
}

export default connect()(UserCostSelect);



// WEBPACK FOOTER //
// ./src/components/Select/UserCostSelect.js